export const toDateOnly = (value: Date | string | null | undefined): string | null => {
  if (!value) return null;

  const d = value instanceof Date ? value : new Date(value);

  if (isNaN(d.getTime())) {
    console.warn('toDateOnly received invalid date:', value);
    return null;
  }

  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${y}-${m}-${day}`;
};